var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M9 2.24152L10.7011 5.80649C10.8542 6.12727 11.1592 6.34884 11.5115 6.39529L15.4277 6.91151L12.5629 9.63101L13.0792 10.175L12.5629 9.63101C12.3051 9.87572 12.1886 10.2342 12.2533 10.5837L12.9725 14.4677L9.50087 12.5835L9.1431 13.2427L9.50086 12.5835C9.18848 12.414 8.81152 12.4139 8.49913 12.5835L5.02746 14.4677L5.74667 10.5837C5.81138 10.2342 5.6949 9.87572 5.43711 9.63101L2.5723 6.91151L6.48846 6.39529C6.84085 6.34884 7.14581 6.12727 7.29888 5.80649L9 2.24152ZM1.63734 7.03476L1.63796 7.03468C1.63775 7.03471 1.63755 7.03473 1.63734 7.03476L1.57853 6.58862L1.63734 7.03476ZM13.8014 14.9176L13.8008 14.9173L13.8014 14.9176ZM16.3627 7.03476C16.3624 7.03473 16.3622 7.0347 16.362 7.03467L16.3627 7.03476Z",
    stroke: "black",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarInactive);
export default __webpack_public_path__ + "static/media/star_inactive.9228770b4dd5ebde8bcf5f84519d1ecd.svg";
export { ForwardRef as ReactComponent };